import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const FETCH_FROM_OMNI_BUS = createAsyncActionTypes('FETCH_FROM_OMNI_BUS');
export const POLL_OMNIBUS = createAsyncActionTypes('POLL_OMNIBUS');